import React, { useState } from 'react';
import { useLazyQuery } from '@common/hooks';
import { renderSearchResults } from './render-helpers';
import { ErrorHandler, SearchBar } from '@common/components';
import { WORKS_AUTOCOMPLETE_SEARCH_QUERY } from '@institutions/graphql';

export const AppSearch = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const [getSearchResults, { error, loading, data }] = useLazyQuery(
    WORKS_AUTOCOMPLETE_SEARCH_QUERY
  );

  if (error) {
    return (
      <ErrorHandler error={error} log="AppSearch" messageType="contextual" />
    );
  }

  const onSearch = (value: string) => {
    setSearchQuery(value);

    if (value && value.length > 0) {
      getSearchResults({ variables: { searchQuery: value } });
    }
  };

  const formattedData =
    data?.worksAutocompleteSearch && searchQuery.length > 0
      ? renderSearchResults(data.worksAutocompleteSearch)
      : [];

  return (
    <>
      <SearchBar
        onSearch={onSearch}
        loading={loading}
        searchResults={formattedData}
      />
    </>
  );
};
